module.exports = __webpack_public_path__ + "media/images/emblems/Riex-coat_of_arms-62e65458e0e669383c492c7a10f29ac9.svg";